import { Divider, Link, Text } from '@chakra-ui/react';
import styled from 'styled-components';
import logo from '../images/trumpetsss.png';
import img1 from '../images/IMG_9827.png'
import img2 from '../images/image1.png';
import img3 from '../images/image3.png';
import { faLocationPin } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AllContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
`;

const Container = styled.div`
    background-color: #f5f1eb;
    width: 100%;
    height: 800px;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-bottom: 15px;
    padding: 20px;
    text-align: center;

    @media (max-width: 1024px) {
        height: 700px;
    }
    @media (max-width: 700px) {
        height: 600px;
    }
`;

const StyledLocation = styled.div`
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 15px;
    gap: 10px;
    margin-bottom: 5px;
`;

const StyledDetails = styled.div`
    font-size: 15px;

    @media (max-width: 700px) {
        font-size: 10px;
    }
`;

const ImageContainer = styled.div`
    display: flex;
    gap: 15px;
    margin-bottom: 50px;
    justify-content: center;
    width: 100%;
    flex-wrap: wrap;

    img {
        width: calc(33.33% - 10px);
        height: 400px;
        object-fit: cover;
    }

    @media (max-width: 1024px) {
        img:nth-child(1) {
            display: none;
        }
        img {
            width: calc(50% - 10px);
        }
    }

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;

        img {
            width: 100%;
        }
    }
`;

const StyledRSVP = styled.a`
    text-decoration: underline;
    font-size: 30px;
    @media (max-width: 700px) {
        font-size: 20px;
    }
`

export function Dashboard() {

    return (
        <AllContainer>
            <Container>
                <Text style={{ fontSize: '10vw' }}>02.05.26</Text>
                <Divider orientation="horizontal" borderColor="black" width={'70%'} />
                <StyledDetails style={{ marginTop: '40px', fontSize: '20px' }}>BRÚÐKAUP | BRYLLUP</StyledDetails>
                <img src={logo} alt="logo" style={{ height: 'auto', width: '80%', maxWidth: '700px' }} />
                <StyledRSVP href="https://docs.google.com/forms/d/e/1FAIpQLScD42WR0SzLaJr5APZCk2N2ORmFnBse0ivCc_4MgKu5Kt5SWQ/viewform?usp=dialog"
                >RSVP</StyledRSVP>
                <StyledLocation>
                    <FontAwesomeIcon icon={faLocationPin} />
                    <div>REYKJAVÍK, ICELAND</div>
                </StyledLocation>
                <Link href="/gifts" style={{ textDecoration: 'underline' }}>
                    Gjafalisti | Gaveliste
                </Link>
                <div style={{ marginTop: '25px', fontSize: '15px' }}>
                    <div>Vinsamlegast hafið samband við | Vennligst ta kontakt med</div>
                    <Link href="https://www.facebook.com/profile.php?id=100002608159179" style={{ fontWeight: "bold", textDecoration: 'underline' }}>
                        Birgitta Björg
                    </Link>
                    <div>veislustjórann okkar, ef þið viljið halda ræðu eða atriði</div>
                    <div>vår toastmaster, dersom dere ønsker å holde tale eller bidra med et innslag</div>

                </div>

            </Container>
            <ImageContainer>
                <img src={img1} alt="EG+OLL" />
                <img src={img2} alt="OLL+EG" />
                <img src={img3} alt="EG+OLL" />
            </ImageContainer>
        </AllContainer>
    );
}
